
      import Top from './top.vue'
      import type { App, Plugin } from 'vue'

      export const TopPlugin: Plugin = {
        install(app: App) {
          app.component('Top', Top)
        },
      }
      export { Top }
      